import { Box, Divider, Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import type { Fund } from '../../data/types';
import { date, DEMO_TODAY, money } from '../../lib/format';

interface Props {
  fund: Fund;
  holderName: string;
  amount: number;
  callPct: number;
  dueDate: string;
  purpose: string;
  reference: string;
}

export default function CallNoticePreview({
  fund,
  holderName,
  amount,
  callPct,
  dueDate,
  purpose,
  reference,
}: Props) {
  return (
    <Paper variant="outlined" sx={{ p: 3, bgcolor: '#FFFFFF' }}>
      <Typography variant="caption" color="text.secondary">
        Notice preview (PDF and app)
      </Typography>
      <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 2.5, mt: 1 }}>
        <Typography sx={{ fontFamily: "'Manrope', sans-serif", fontWeight: 800, color: '#143c34' }}>
          Fides
        </Typography>
        <Typography variant="h6" sx={{ mt: 1.5 }}>
          Capital call notice
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {fund.name}
        </Typography>
        <Divider sx={{ my: 1.5 }} />
        <Typography variant="body2">
          To: <strong>{holderName}</strong>
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          Under the trust deed, the trustee calls {callPct}% of your commitment. Purpose: {purpose}.
        </Typography>
        <Stack spacing={0.5} sx={{ mt: 2, p: 1.5, bgcolor: '#F8FAFC', borderRadius: 1 }}>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2">Amount due</Typography>
            <Typography variant="body2" sx={{ fontWeight: 700 }}>
              {money(amount)}
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2">Due date</Typography>
            <Typography variant="body2">{date(dueDate)}</Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2">BPAY biller code</Typography>
            <Typography variant="body2">{fund.bpayBillerCode}</Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2">BPAY reference</Typography>
            <Typography variant="body2">{reference}</Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2">Or EFT to</Typography>
            <Typography variant="body2">
              {fund.bank.bsb} · {fund.bank.accountNumber}
            </Typography>
          </Stack>
        </Stack>
        <Typography variant="caption" color="text.secondary" component="div" sx={{ mt: 1.5 }}>
          Issued {date(DEMO_TODAY)}. Late payment may attract default interest under clause 9 of the
          trust deed. Pay in the Fides app under Payments.
        </Typography>
      </Box>
    </Paper>
  );
}
